---
title: Home
summary: "Your Home page is a set of cards about the work in front of you. Customize chooses which cards show and where."
visibility: authenticated
feature: home_dashboard
audience: end-user
section: Pages
order: 10
last_verified: 2026-10-26
owner: docs
routes: ['/']
aliases: [dashboard, start page, front page, overview, widgets, cards]
tour:
  - anchor: home.widgets.grid
    text: "Each card counts or lists one part of the work, and a number links to the list it counts. A card you may not see is left out for you."
  - anchor: home.header.customize
    text: "Customize lets you move, resize, add and remove cards. Your layout is yours alone."
  - anchor: home.customize.add
    reveal: home.header.customize
    text: "Add a widget lists every card you can put back or add, grouped by what each card is about: the aircraft, your work, the customers and the business."
    when_missing: "Customize is not open."
  - anchor: home.customize.done
    reveal: home.header.customize
    text: "Done keeps your changes and closes Customize."
    when_missing: "Customize is not open."
---

# Home

Home opens when you sign in. It is a page of cards, each about one part of the work:
what is waiting for you, what arrived, what is with customers and what was decided.
A number on a card links to the list it counts, already filtered, so the register or
the task list opens on exactly those rows.

## The cards

What a card shows depends on what you may see. The cards a deployment offers include:

- **Operation**: the fleet's day at a glance, where the fleet is in use.
- **At a glance**: the headline counts for the work in hand.
- **Briefing**: a short summary of what changed.
- **My work**: the tasks waiting for you or your seat.
- **New enquiries**: requests that arrived and have no owner yet.
- **Quotes with customers** and **Open quotes**: what is out with customers and what is still being worked.
- **Decisions pending**: quotes waiting for a pricing decision.
- **Block hours this month** and **Closed this month**: the month so far.

A card you may not see stays in your layout and is skipped when the page is drawn,
so nothing moves when your permissions change.

## Change what Home shows

1. Press **Customize**. A banner says Customize is open.
2. Drag a card, or use its move arrows, to change its place; change its width the same way. On a wide page, between full-width cards, wide cards stack on the left and narrow cards on the right. On a narrower page narrow cards sit two to a row, then every card takes a row of its own; a card too narrow to read shows its key figure and a link.
3. Press **Add a widget** to add a card, or remove one from its own corner.
4. Press **Done** to keep your changes. **Reset to default** brings back the starting layout.

Your layout is stored for you alone. A card added to the product later appears under
**Add a widget**; it is never put on a page you have already customized.
